import * as S from "./styles";
// import { useScreenSize } from "../../hooks/useScreenSize";
import bicGif from '../../assets/bic.gif';

const SectionBic = () => {
  return (
    <S.SectionBic id="toBic" data-section="section_bic">
      <img src={bicGif} alt="bic" />
    </S.SectionBic>
  )
}

export default SectionBic